<template>
  <div id="grid-proveedor">
    <v-container grid-list-xl fluid>
      <template>
        <v-layout justify-center>
          <v-flex lg12>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn v-if="btnHidden != true && getCodigoPerfil !== 'LEC'" color="success" @click="newContrato">Nuevo</v-btn>
            </v-card-actions>
            <div v-if="loading">
              <loading></loading>
            </div>
            <v-data-table :headers="headers" :items="itemsProveedor" :rows-per-page-items="rowsTable"
              class="elevation-1">
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.periodo }}</td>
                <td class="text-xs-left">{{ props.item.proveedor.rut }}</td>
                <td class="text-xs-left">
                  {{ props.item.proveedor.razonSocial }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.proveedor.idComuna.idRegion.nombre }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.proveedor.idComuna.nombre }}
                </td>
                <td class="text-xs-left columnaLarga">
                  {{ props.item.descripcion }}
                </td>
                <td class="text-xs-center">
                  <v-btn depressed outline icon fab dark color="green darken-4" small title="Ver contrato" @click="
                    openProveedorTab(
                      props.item.id,
                      props.item.codigo,
                      props.item.proceso,
                      props.item.proveedor.razonSocial,
                      props.item.periodo,
                      props.item.cerrado
                    )
                    ">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <!-- muestra un boton por cada tipo de proceso asociado por grupo -->
                  <v-tooltip v-if="mostrarCirculo(props.item.procesos, dupla.nombre)" bottom
                    v-for="(dupla, palabraIndex) in nomBotones" :key="palabraIndex" class="boton">
                    <span slot="activator" :class="'circle circle' + dupla.btn" @click="
                      openProgresoTab(
                        props.item.id,
                        props.item.codigo,
                        props.item.proceso,
                        props.item.proveedor.razonSocial,
                        dupla.nombre,
                        props.item.periodo,
                        props.item.cerrado
                      )
                      ">{{ dupla.btn }}</span>
                    <span>{{ dupla.nombre }}</span>
                  </v-tooltip>
                  <!-- muestra espacio  -->
                  <span v-else class="circleVacio">&nbsp;</span>
                  <v-btn v-if="editIcon && btnEdit != true && getCodigoPerfil !== 'LEC'" depressed outline icon fab dark
                    color="primary" small title="Editar contrato" @click="editContrato(props.item.id)">
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <!-- LEYENDA TABLA PROVEEDORES -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <div class="text-xs-center">
                <td>
                  <template>
                    <v-btn class="btn-sigas" depressed outline icon fab dark color="green darken-4" small>
                      <v-icon>remove_red_eye</v-icon> </v-btn>&nbsp;Ver contrato
                  </template>
                  <template>
                    <span class="circle circleAPL"> APL </span>&nbsp;Aplicación
                  </template>
                  <template>
                    <span class="circle circleIMD"> IMD </span>&nbsp;Impresión
                  </template>
                  <template>
                    <span class="circle circleCAP"> CAP </span>&nbsp;Capacitación
                  </template>
                  <template>
                    <span class="circle circleCRA"> CRA </span>&nbsp;Captura
                  </template>
                  <template>
                    <span class="circle circlePAB"> PAB </span>&nbsp;Preguntas
                    Abiertas
                  </template>
                  <template>
                    <span class="circle circleVAL"> VAL </span>&nbsp;Validación
                  </template>
                  <template v-if="editIcon && btnEdit != true">
                    <v-btn class="btn-sigas" depressed outline icon fab dark color="primary" small>
                      <v-icon>open_in_new</v-icon> </v-btn>&nbsp;Editar contrato
                  </template>
                </td>
              </div>
            </v-card-actions>
            <!--fin iconos leyenda-->
          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { misRoles } from "@/mixins/roles.js";
import Loading from "@/views/ui/Loading.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-proveedor",
  components: {
    Loading,
  },
  mixins: [misRoles],
  props: {
    itemsProveedor: {},
    rowsTable: [],
    editIcon: Boolean,
  },
  data() {
    return {
      proceso: "",
      userlogged: "",
      btnEdit: false,
      loading: false,
      headers: [
        { text: "Periodo", sortable: false, value: "" },
        { text: "RUT", sortable: false, value: "" },
        { text: "Proveedor", sortable: false, value: "" },
        { text: "Región", sortable: false, value: "" },
        { text: "Comuna", sortable: false, value: "" },
        { text: "Descripción", sortable: false, value: "" },
        { text: "Accion", sortable: false, value: "" },
      ],
      id: Number,
      btnHidden: false,
      nomBotones: [
        { nombre: "IMPRESIÓN", btn: "IMD" },
        { nombre: "APLICACION", btn: "APL" },
        { nombre: "CAPACITACION", btn: "CAP" },
        { nombre: "CAPTURA", btn: "CRA" },
        { nombre: "PREGUNTAS", btn: "PAB" },
        { nombre: "VALIDACIÓN", btn: "VAL" },
      ],
    };
  },
  mounted: function () {
    this.$store.commit("proveedor_state", "");
    this.$store.commit("contrato_cod", "");
    this.$store.commit("contrato_periodo", "");
    this.$store.commit("contrato_cerrado", false);

  },
  created() {
    // console.log("st::userLogged:" + JSON.stringify(this.$store.getters.userLogged, null, 2));
    this.userLogged = this.$store.getters.userLogged.id;
    if (this.$store.getters.userLogged.tipo == "PROVEEDOR") {
      this.btnHidden = true;
      this.btnEdit = true;
    } else {
      this.btnHidden = false;
      this.btnEdit = false;
    }
  },
  computed: {
    
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      console.log("CODIGO DE USUARIO PROVEEDOR:", user);
      return user.perfil.codigo
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    openProveedorTab(
      id,
      codigoContrato,
      proceso,
      razonSocial,
      periodo,
      cerrado
    ) {
      this.$store.commit("contrato_state", id);
      this.$store.commit("contrato_cod", codigoContrato);
      this.$store.commit("contrato_periodo", periodo);
      this.$store.commit("pro_state", proceso);
      this.$store.commit("proveedor_state", razonSocial);
      this.$store.commit("tab_state", "Proveedor");
      this.$store.commit("contrato_cerrado", cerrado);

      const contratoCerradoConId = {
        id: id,
        cerrado: cerrado
      };
      const contratoCerradoConIdJSON = JSON.stringify(contratoCerradoConId);
      localStorage.setItem("contratoCerradoConId", contratoCerradoConIdJSON);

      // console.log("carga proveedor::" + this.$store.getters.contratoStored);

      this.setUsuRolInContract(id);
      let procesoSelect = proceso;
      if (procesoSelect == "IMPRESIÓN") {
        this.$router.push({
          name: "ProcesoImpresion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (procesoSelect == "APLICACION") {
        this.$router.push({
          name: "ProcesoAplicacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (procesoSelect == "CAPACITACION") {
        this.$router.push({
          name: "ProcesoCapacitacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (procesoSelect == "CAPTURA") {
        this.$router.push({
          name: "ProcesoCaptura",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (procesoSelect == "PREGUNTAS") {
        this.$router.push({
          name: "ProcesoPreguntas",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (procesoSelect == "VALIDACIÓN") {
        this.$router.push({
          name: "ProcesoValidaciones",
          params: { contratoId: id, tipeView: "consulta" },
        });
      }
    },
    mostrarCirculo(procesos, nombre) {
      return Object.values(procesos).includes(nombre);
    },
    async cargaContratoAsociado(id, proceso) {
      return await axios
        .post("/contratoAsociadoProceso/" + id + "/" + proceso)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async openProgresoTab(
      id,
      codigoContrato,
      proceso,
      razonSocial,
      nombreNuevo,
      periodo,
      cerrado
    ) {
      // console.log("codigoContrato::" + proceso + "::" + nombreNuevo);
      this.loading = true;
      this.$store.commit("contrato_periodo", periodo);
      this.$store.commit("proveedor_state", razonSocial);
      this.$store.commit("contrato_cerrado", cerrado);
      const contratoCerradoConId = {
        id: id,
        cerrado: cerrado
      };
      const contratoCerradoConIdJSON = JSON.stringify(contratoCerradoConId);
      localStorage.setItem("contratoCerradoConId", contratoCerradoConIdJSON);
      if (proceso == nombreNuevo) {
        this.$store.commit("contrato_state", id);
        this.$store.commit("contrato_cod", codigoContrato);
        this.$store.commit("pro_state", proceso);
      } else {
        let contrato = await this.cargaContratoAsociado(id, nombreNuevo);
        this.$store.commit("contrato_state", contrato.id);
        this.$store.commit("contrato_cod", contrato.codigo);
        this.$store.commit("pro_state", contrato.proceso);
        id = contrato.id;
        // console.log("busca::" + nombreNuevo + "::" + contrato.id + "::" + contrato.proveedor.razonSocial);
      }
      this.setUsuRolInContract(id);
      if (nombreNuevo == "IMPRESIÓN") {
        this.$store.commit("tab_state", "Validaciones");
        this.$router.push({
          name: "ProcesoImpresion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nombreNuevo == "APLICACION") {
        this.$store.commit("tab_state", "Proceso");
        this.$router.push({
          name: "ProcesoAplicacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nombreNuevo == "CAPACITACION") {
        this.$store.commit("tab_state", "Proceso");
        this.$router.push({
          name: "ProcesoCapacitacion",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nombreNuevo == "CAPTURA") {
        this.$store.commit("tab_state", "Proceso");
        this.$router.push({
          name: "ProcesoCaptura",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nombreNuevo == "PREGUNTAS") {
        this.$store.commit("tab_state", "Proceso");
        this.$router.push({
          name: "ProcesoPreguntas",
          params: { contratoId: id, tipeView: "consulta" },
        });
      } else if (nombreNuevo == "VALIDACIÓN") {
        this.$store.commit("tab_state", "Proceso");
        this.$router.push({
          name: "ProcesoValidaciones",
          params: { contratoId: id, tipeView: "consulta" },
        });
      }
    },
    editContrato(id) {
      this.$store.commit("contrato_state", id);
      this.setUsuRolInContract(id);
      this.$router.push({
        name: "ContratoEdit",
        params: { contratoId: id, tipeView: "modifica" },
      });
    },
    newContrato() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContratoRegis",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },
    changeData(event) {
      this.itemsProveedor = event.target.value;
    },

    async setUsuRolInContract(id) {
      let user = await this.loadUsuarioData(id);
      if (user) {
        if (user.tipo == "ADMINISTRADOR") {
          this.$store.commit("rolInContract_state", {
            nombre: "Administrador",
          });
        } else {
          let rolesUsuario = this.getRol(user.lstUsuContratoRol);
          this.getUsuRolContrato(rolesUsuario);
        }
      }

      this.tipoRol = this.$store.getters.rolIncontractStored;
    },
    async loadUsuarioData(id) {
      if (this.userLogged) {
        return await axios
          .get("/user/" + this.userLogged + "/contrato/" + id)
          .then((response) => {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
};
</script>

<style>
.boton {
  margin-right: 5px;
}

.circle {
  display: inline-block;
  width: 40px;
  /* Ajusta el ancho del circulo */
  height: 40px;
  /* Ajusta la altura del circulo */
  border-radius: 50%;
  background-color: white;
  /* Fondo blanco */
  color: rgb(3, 3, 80);
  /* Color de las letras */
  text-align: center;
  line-height: 40px;
  /* Ajusta el centrado vertical del texto */
  border: 2px solid rgb(3, 3, 80);
  /* Borde azul */
  cursor: pointer;
}

.circleIMD {
  color: rgb(3, 3, 80);
  /* Color de las letras */
  border: 2px solid rgb(3, 3, 80);
  /* Borde azul */
}

.circleAPL {
  color: rgb(3, 80, 29);
  /* Color de las letras */
  border: 2px solid rgb(3, 80, 29);
  /* Borde azul */
}

.circleCAP {
  color: rgb(104, 32, 92);
  /* Color de las letras */
  border: 2px solid rgb(104, 32, 92);
  /* Borde azul */
}

.circleCRA {
  color: rgb(212, 138, 25);
  /* Color de las letras */
  border: 2px solid rgb(212, 138, 25);
  /* Borde azul */
}

.circlePAB {
  color: rgb(80, 3, 3);
  /* Color de las letras */
  border: 2px solid rgb(80, 3, 3);
  /* Borde azul */
}

.circleVAL {
  color: rgb(13, 109, 173);
  /* Color de las letras */
  border: 2px solid rgb(13, 109, 173);
  /* Borde azul */
}

.circleVacio {
  display: inline-block;
  margin-right: 5px;
  width: 40px;
  /* Ajusta el ancho del círculo */
  height: 40px;
  /* Ajusta la altura del círculo */
  /* border-radius: 50%; */
  text-align: center;
  line-height: 40px;
  /* Ajusta el centrado vertical del texto */
}

.columnaLarga {
  max-width: 400px;
  /* Establece el ancho máximo de la columna */
  word-wrap: break-word;
  /* Permite que el texto largo se ajuste a varias filas */
}
</style>
